module.exports = __webpack_public_path__ + "static/media/glyph-energy.6d60ea70.svg";